<template>
  <v-container fluid class="mb-12">
    <v-row class="no-indentation">
      <v-col lg="3" md="3" sm="12" class="pt-0 products-menu">
        <products-submenu />
      </v-col>
      <v-col v-if='check_current_product' lg="8" md="8" sm="12" class="pa-8 product-description">
        <v-container fluid class="pt-0">
          <v-row class="no-indentation description-block" >
            <v-col sm="12" md="6" lg="4" class="pa-0">
              <v-img v-if="current_product.photo"
                     :src="current_product.photo"
                     max-height="312"
                     contain
                     class="product_img"
              />
              <v-img v-else
                     src="../../public/img/no-photo.png"
                     max-height="312"
                     contain
              />
            </v-col>
            <v-col sm="12" md="6" lg="8" class="pa-0 description-block__text-col">
              <div class="description-block__content">
                <header>{{ current_product.name }}</header>
                <v-container fluid class="pa-0">
                  <v-row class="no-indentation mb-2">
                    <v-col cols="12" class="pa-0 product__text">
                      <div>{{ current_product.manufacturer }}</div>
                    </v-col>
                  </v-row>
                  <v-row class="no-indentation mb-2">
                    <v-col cols="12" class="pa-0 product__text">
                      <div>{{ current_product.country }}</div>
                    </v-col>
                  </v-row>
                  <v-row class="no-indentation mb-2">
                    <v-col cols="12" class="pa-0 product__text">
                      <div v-for="category in current_product.categories" :key="category">
                        {{ category+' ' }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="no-indentation mb-2">
                    <v-col cols="12" class="pa-0 product__text">
                      <div>{{ current_product.name_mnn }}</div>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <div class="description-block__btn-wrap">
                <v-btn class="products-list__more-btn"
                       color="light-green darken-4"
                       depressed
                       @click="orderDialog = true"
                >
                  <h3>{{ $t('message.productsPageProductOrderButton') }}</h3>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row class="order-block">
            <v-col cols="12" v-if="check_buy_urls">
              <h3>{{ $t('message.productsPageProductSubHead1') }}</h3>
              <div class="d-flex">
                <v-btn outlined
                       v-if="current_product.gorpharm_url"
                       class="order-block__btn bg-white"
                       :href="current_product.gorpharm_url"
                       target="_blank"
                >
                  <img src="../../public/img/orders/GA_full.jpg"/>
                </v-btn>
                <v-btn outlined
                       v-if="current_product.zdaravcity_url"
                       class="order-block__btn bg-blue"
                       :href="current_product.zdaravcity_url"
                       target="_blank"
                >
                  <svg viewBox="0 0 220 29"
                       fill="none"
                       xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M214.452 1.85076C212.389 -0.189756 209.044 -0.189756 206.98 1.85076L204.352 4.45065L201.723 1.85076C199.66 -0.189756 196.315 -0.189756 194.252 1.85076C192.189 3.89128 192.189 7.20023 194.252 9.24074L196.88 11.8406L204.352 19.2306L214.452 9.24074C216.515 7.20023 216.515 3.89325 214.452 1.85076Z" fill="#FF5B00"></path>
                    <path d="M17.9899 13.9311C17.9899 17.827 14.4333 19.7926 9.41312 19.7926C3.17222 19.7946 0.696973 16.8973 0 12.9994H5.05604C5.44037 15.2409 6.79848 16.0346 9.30957 16.0346C11.8545 16.0346 12.9358 15.1384 12.9358 13.5864C12.9358 12.4479 12.3782 11.5518 10.1459 11.5518H6.93787V7.7583H9.62222C11.7131 7.7583 12.3424 7.10242 12.3424 5.89702C12.3424 4.58723 11.506 3.6556 9.06464 3.6556C7.35606 3.6556 5.82271 4.13815 5.43838 6.10383H0.384331C1.01161 2.75943 3.31162 0 9.13433 0C13.9454 0 17.3626 1.93022 17.3626 5.55234C17.3626 7.48255 16.3868 8.65644 14.9909 9.34581C16.8747 10.1041 17.9899 11.7251 17.9899 13.9311Z" fill="white"></path>
                    <path d="M43.4056 14.7251V24.1734H38.4193V19.3793H24.0198V24.1734H19.0355V14.7251H22.4526C23.1157 14.1736 23.5339 13.0707 23.8466 11.1385L25.589 0.41394H39.9188V14.7251H43.4056ZM34.9324 14.7251V5.0701H29.8425L28.7971 11.3807C28.5521 12.9328 28.2036 13.9668 27.7158 14.7251H34.9324Z" fill="white"></path>
                    <path d="M65.2479 9.8973C65.2479 15.7254 61.4822 19.7946 56.4959 19.7946C53.7757 19.7946 51.7884 18.6227 50.4302 16.8284V28.002H45.4439V0.413618H50.4302V3.06866C51.7565 1.24086 53.8136 0 56.4979 0C61.4125 0 65.2479 4.03376 65.2479 9.8973ZM60.1938 9.8973C60.1938 6.79319 58.1368 4.68965 55.3469 4.68965C52.557 4.68965 50.4302 6.79319 50.4302 9.8973C50.4302 13.0349 52.557 15.105 55.3469 15.105C58.1009 15.103 60.1938 13.0349 60.1938 9.8973Z" fill="white"></path>
                    <path d="M86.8852 0.413618L86.8494 19.379H81.863V16.8284C80.5388 18.6207 78.5514 19.7946 75.8671 19.7946C70.8469 19.7946 67.1151 15.7254 67.1151 9.8973C67.1171 4.03376 70.9166 0 75.8332 0C78.5534 0 80.5746 1.24086 81.8989 3.06866V0.413618H86.8852ZM81.8989 9.8973C81.8989 6.79319 79.7721 4.68965 76.9822 4.68965C74.1924 4.68965 72.1353 6.79319 72.1353 9.8973C72.1353 13.0349 74.2262 15.105 76.9822 15.105C79.7721 15.103 81.8989 13.0349 81.8989 9.8973Z" fill="white"></path>
                    <path d="M106.412 13.8979C106.412 17.7938 103.379 19.3813 99.4378 19.3813H89.2919V0.41394H98.5656C102.401 0.41394 105.434 1.4145 105.434 5.20798C105.434 7.17365 104.388 8.2077 102.959 9.13932C105.191 9.79323 106.412 11.4832 106.412 13.8979ZM98.1494 4.27635H94.2802V7.93195H98.1494C99.858 7.93195 100.416 7.31152 100.416 6.1396C100.416 4.89678 99.858 4.27635 98.1494 4.27635ZM101.357 13.4488C101.357 12.1036 100.73 11.4497 99.0555 11.4497H94.2782V15.5189H99.0555C100.798 15.5189 101.357 14.8276 101.357 13.4488Z" fill="white"></path>
                    <path d="M107.872 9.8973C107.872 4.27603 112.09 0 117.877 0C122.548 0 126.698 2.79291 127.429 7.62043H122.304C121.71 5.55233 119.898 4.55177 117.875 4.55177C114.842 4.55177 112.888 6.75971 112.924 9.8973C112.888 13.0703 114.912 15.2428 117.841 15.2428C119.898 15.2428 121.71 14.2088 122.304 12.1387H127.429C126.663 17.1396 122.443 19.7946 117.841 19.7946C112.09 19.7946 107.872 15.5186 107.872 9.8973Z" fill="white"></path>
                    <path d="M147.774 0.41394V19.3793H142.788V12.6551L143.102 7.03381L135.189 19.3793H129.436V0.41394H134.422V7.1382L134.177 12.6905L142.057 0.41394H147.774Z" fill="white"></path>
                    <path d="M166.6 5.0701H160.674V19.3813H155.688V5.0701H149.795V0.41394H160.672H166.598V5.0701H166.6Z" fill="white"></path><path d="M186.89 0.41394V19.3793H181.904V12.6551L182.219 7.03381L174.305 19.3793H168.552V0.41394H173.538V7.1382L173.294 12.6905L181.173 0.41394H186.89Z" fill="white"></path>
                    <path d="M196.88 11.8428L194.251 9.24288C192.188 7.20236 192.188 3.89342 194.251 1.8529C196.314 -0.18762 199.66 -0.18762 201.723 1.8529L204.351 4.45279L196.88 11.8428Z" fill="#FF8150"></path>
                  </svg>
                </v-btn>
                <v-btn outlined
                       v-if="current_product.ytera_url"
                       class="order-block__btn bg-white"
                       :href="current_product.ytera_url"
                       target="_blank"
                >
                  <svg xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink"
                       class="uteka"
                       viewBox="0 0 146 40"
                  >
                    <g id="Canvas" transform="translate(9379 3040)">
                      <g id="logo">
                        <g id="logo copy">
                          <use xlink:href="#path0_fill" transform="translate(-9379 -3040)" fill="#2CB143"/>
                        </g>
                        <g>
                          <use xlink:href="#path1_fill" transform="translate(-9329 -3031)" fill="#212121"/>
                        </g>
                      </g>
                    </g>
                    <defs>
                      <path id="path0_fill" fill-rule="evenodd" d="M 0 20.0237C 0 8.9729 8.98926 0 20.1182 0C 31.248 0 40.3799 8.92554 40.3799 19.9763C 40.3799 31.0271 31.3428 40 20.2139 40C 14.8867 40 9.98828 37.9221 6.37305 34.5217L 14.8867 26.9658C 16.3613 28.0991 18.2158 28.7603 20.2139 28.7603C 25.0645 28.7603 29.0127 24.8406 29.0127 20.0237C 29.0127 15.2065 25.0645 11.2869 20.2139 11.2869C 15.3623 11.2869 11.415 15.2065 11.415 20.0237C 11.415 21.6765 11.8428 23.1877 12.6514 24.51L 4.08984 32.0662C 1.52148 28.7131 0 24.5574 0 20.0237ZM 23.8779 25.0203C 23.6357 24.7446 23.6836 24.2849 23.9746 24.0552C 25.3301 23.0442 26.1045 21.4819 26.0557 19.8276C 26.0557 18.3572 25.4268 16.9326 24.3135 15.9219C 24.0225 15.646 24.0225 15.2324 24.3135 14.9568C 24.6035 14.6812 25.0391 14.6812 25.3301 14.9568C 26.7334 16.2434 27.5078 17.9895 27.5078 19.8276C 27.5078 21.8955 26.5889 23.8254 24.8945 25.1121C 24.7979 25.2041 24.6035 25.25 24.459 25.25C 24.2168 25.25 24.0225 25.2041 23.8779 25.0203Z"/>
                      <path id="path1_fill" fill-rule="evenodd" d="M 0 21.6262L 0 0.244364L 3.60775 0.244364L 3.60775 9.744L 8.10972 9.744C 8.47975 6.93382 9.65149 4.61236 11.5941 2.74909C 13.5368 0.916364 15.7877 0 18.3779 0C 21.0606 0 23.3116 1.008 25.0692 2.99345C 26.8268 4.97891 27.7211 7.48364 27.7211 10.4465C 27.7211 13.6538 26.7035 16.3418 24.6992 18.5411C 22.6641 20.7709 20.2281 21.8705 17.3604 21.8705C 14.7393 21.8705 12.5192 20.8931 10.7616 18.9687C 9.00395 17.0444 8.07889 14.6618 8.01721 11.76L 3.60775 11.76L 3.60775 21.6262L 0 21.6262ZM 11.7178 10.1411C 11.7178 12.7374 12.3345 14.9367 13.5987 16.7389C 14.863 18.5411 16.4048 19.4574 18.2549 19.4574C 19.9508 19.4574 21.3384 18.7244 22.4177 17.2887C 23.4969 15.8531 24.0211 13.9898 24.0211 11.7294C 24.0211 9.13309 23.3736 6.90327 22.1093 5.10109C 20.8451 3.2989 19.2725 2.41309 17.4223 2.41309C 15.7264 2.41309 14.3696 3.14618 13.3212 4.58181C 12.242 6.01745 11.7178 7.88072 11.7178 10.1411ZM 44.3727 6.96436L 29.8184 6.96436L 29.8184 9.07199L 35.3687 8.91926L 35.3687 21.6262L 38.8223 21.6262L 38.8223 8.91926L 44.3727 9.07199L 44.3727 6.96436ZM 49.7069 14.8756C 49.8611 16.3418 50.4162 17.4414 51.3104 18.1745C 52.2046 18.9382 53.438 19.3047 54.949 19.3047C 55.9049 19.3047 56.7991 19.1825 57.6625 18.9382C 58.495 18.6938 59.1118 18.4494 59.5126 18.2051L 60.0985 17.808L 60.0985 19.7629C 60.0368 19.824 59.9443 19.8851 59.8518 19.9767C 59.7285 20.0683 59.4818 20.2516 59.0809 20.496C 58.6801 20.7403 58.2792 20.9542 57.8475 21.1374C 57.385 21.3207 56.8299 21.4734 56.1207 21.6567C 55.4115 21.8094 54.6714 21.8705 53.9314 21.8705C 51.5571 21.8705 49.6453 21.1985 48.2268 19.824C 46.7776 18.4494 46.0684 16.7389 46.0684 14.6312C 46.0684 12.4014 46.8701 10.5076 48.4427 8.98033C 50.0153 7.48361 51.9271 6.71997 54.2398 6.71997C 56.3366 6.71997 57.94 7.39197 59.0501 8.73597C 60.1293 10.08 60.6844 11.9432 60.6844 14.3563L 59.7593 14.8756L 49.7069 14.8756ZM 53.7767 8.98047C 52.6975 8.98047 51.7724 9.34701 51.0632 10.0496C 50.354 10.7521 49.8915 11.7296 49.7373 12.9514L 57.5078 12.9514C 57.107 10.2939 55.8427 8.98047 53.7767 8.98047ZM 67.4991 6.96436L 64.3848 6.96436L 64.3848 21.6262L 67.8383 21.6262L 67.8383 15.2422L 69.1334 15.0284L 74.2829 21.6262L 78.1682 21.6262L 71.7853 13.3484L 77.274 6.96436L 74.468 6.96436L 69.2876 13.0734L 67.8383 13.2873L 67.8383 7.72799L 67.4991 6.96436ZM 92.5059 11.5156L 92.5059 18.4189C 92.5059 19.152 92.8143 19.5185 93.4618 19.5185C 93.6777 19.5185 93.9552 19.4574 94.2327 19.3658C 94.5102 19.2742 94.7569 19.2131 94.9111 19.1214L 95.1886 18.9687L 95.1886 20.8014C 94.2944 21.504 93.1535 21.8705 91.7659 21.8705C 90.2549 21.8705 89.3607 21.2596 89.114 20.0378C 87.8189 21.2596 86.2155 21.8705 84.3037 21.8705C 82.8853 21.8705 81.806 21.504 81.0968 20.8014C 80.3876 20.0989 80.0176 19.2436 80.0176 18.2051C 80.0176 17.5636 80.1718 16.9832 80.4493 16.464C 80.7268 15.9447 81.0968 15.4865 81.5593 15.12C 81.991 14.784 82.5153 14.448 83.132 14.1731C 83.7487 13.8982 84.3345 13.6843 84.8896 13.5316C 85.4138 13.3789 85.9997 13.2567 86.6472 13.1345C 87.2947 13.0429 87.7573 12.9512 88.0965 12.9207C 88.4357 12.8902 88.744 12.8902 89.0524 12.8596L 89.0524 12.1571C 89.0524 11.2102 88.744 10.4771 88.1273 9.92724C 87.4798 9.40797 86.5547 9.13306 85.3213 9.13306C 84.5196 9.13306 83.7487 9.25524 83.0395 9.46906C 82.2994 9.71343 81.7752 9.95779 81.436 10.2022L 80.9426 10.5382L 80.9426 8.67488C 81.0043 8.61379 81.0968 8.5527 81.1893 8.46106C 81.2818 8.36942 81.5285 8.2167 81.9294 8.00288C 82.2994 7.78906 82.7003 7.57524 83.132 7.39197C 83.5637 7.23924 84.1187 7.08652 84.7971 6.93379C 85.4754 6.78106 86.1847 6.71997 86.9247 6.71997C 88.8057 6.71997 90.1933 7.14761 91.1183 7.97233C 92.0434 8.79706 92.5059 9.98833 92.5059 11.5156ZM 83.502 17.5941C 83.502 18.1744 83.7178 18.6632 84.1803 19.0297C 84.6429 19.4268 85.2287 19.6101 85.9996 19.6101C 87.0789 19.6101 88.0964 19.213 89.0523 18.4493L 89.0523 14.5701C 88.6206 14.6006 88.1581 14.6312 87.6956 14.7228C 87.2022 14.8144 86.6163 14.9366 85.9071 15.1199C 85.1979 15.3337 84.6429 15.6392 84.1803 16.0668C 83.7178 16.4944 83.502 17.0137 83.502 17.5941Z"/>
                    </defs>
                  </svg>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row class="tabs-block">
            <v-col cols="12">
              <v-tabs v-model="tab"
                      grow
                      color="light-green darken-2"
              >
                <v-tab>{{ $t('message.productsPageSliderTab1') }}</v-tab>
                <v-tab v-if="current_product.certificate.length > 0">
                  {{ $t('message.productsPageSliderTab2') }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" class="product-tab-items">
                <v-tab-item>
                  <product-instruction />
                </v-tab-item>
                <v-tab-item v-if="current_product.certificate.length > 0">
                  <v-container fluid class="no-indentation">
                    <v-row class="no-indentation">
                      <v-col cols="12" lg="4" md="4" sm="10" class="mx-auto text-center pa-0">
                        <product-sertificate />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <product-order-form-dialog
      v-model="orderDialog"
      :id_name_org-label="420"
      :id_adress-label="421"
      :id_email-label="422"
      :id_phone-label="423"
      :change="true"
    />
  </v-container>
</template>
<style>
 .scale{
   transition: 1s;
 }
 .scale:hover {
   transform: scale(2);
 }
</style>
<script>
import '../assets/sass/app.scss'
import '../plugins/i18n.js'
import ProductInstruction from '@/components/ui/ProductInstruction.vue'
import ProductSertificate from '@/components/ui/ProductSertificate'
import ProductOrderFormDialog from '@/components/ui/ProductOrderFormDialog.vue'

export default {
  components: { ProductInstruction, ProductSertificate, ProductOrderFormDialog },
  data () {
    this.$store.dispatch('groups/GET_DATA')
    this.$store.dispatch('products/GET_DATA')
    if (!isNaN(this.$route.params.id_product)) {
      let currentGroup = this.$store.getters['groups/get_current']
      if (typeof currentGroup === 'undefined') {
        this.$store.dispatch('groups/SET_CURRENT_BY_PRODUCT_ID', this.$route.params.id_product)
      }
      if (!isNaN(this.$route.params.id_product)) { this.$store.dispatch('products/SET_CURRENT', { id: this.$route.params.id_product }) }
    }
    return {
      orderDialog: false,
      tab: null,
      items: [
        'Инструкция', 'Сертификаты'
      ],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  computed: {
    lang () { return this.$i18n.locale },
    current_product () {
      let db_product = this.$store.state['products']['current']
      let res_product = {
        id: db_product.id,
        certificate: db_product.certificate,
        gorpharm_url: db_product.gorpharm_url,
        instruction: db_product.instruction,
        photo: db_product.photo,
        post: db_product.post,
        recipe: db_product.recipe,
        ytera_url: db_product.ytera_url,
        zdaravcity_url: db_product.zdaravcity_url
      }
      if (this.lang === 'ru') {
        res_product['country'] = db_product.country_rus
        res_product['manufacturer'] = db_product.manufacturer_rus
        res_product['name_mnn'] = db_product.name_mnn_rus
        res_product['name'] = db_product.name_rus
        res_product['categories'] = Array.from(db_product.groups, group => group.name_rus)
      }
      if (this.lang === 'en-US') {
        res_product['country'] = db_product.country_en
        res_product['manufacturer'] = db_product.manufacturer_en
        res_product['name_mnn'] = db_product.name_mnn_en
        res_product['name'] = db_product.name_en
        res_product['categories'] = Array.from(db_product.groups, group => group.name_en)
      }
      return res_product
    },
    check_buy_urls () {
      return this.current_product.gorpharm_url || this.current_product.zdaravcity_url || this.current_product.ytera_url
    },
    check_current_product () {
      return this.$store.state.products.current.id === Number(this.$route.params.id_product)
    }
  },
  watch: {
    '$store.state.products.current' () {
      this.$store.dispatch('products/SET_SERTIFICATE')
    }
  },
  metaInfo () {
    let product_name = this.$store.state['products']['current']['name_mnn_rus'] ? this.$store.state['products']['current']['name_mnn_rus'] : 'товар'
    return {
      meta: [
        {
          name: 'description',
          content: 'Заказать' + product_name + 'от компании Фарм-Инновации'
        },
        { name: 'title',
          content: 'Продукт' +  product_name
        }
      ]
    }
  }
}
</script>
